import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Outlet layout for /sales/$id and any child routes (e.g. /sales/$id/pick).
 * The actual sale detail page lives in sales.$id.index.tsx. See
 * [[tanstack-route-layout-pattern]] in memory.
 */
export const Route = createFileRoute("/sales/$id")({
  component: SaleIdLayout,
});

function SaleIdLayout() {
  return <Outlet />;
}
